import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { useDispatch } from 'react-redux';

import WritersList from './components/writers-list/WritersList';
import AddWriter from './components/add-writer/AddWriter';
import EditWriter from './components/edit-writer/EditWriter';
import { resetScoutSettingsData } from '../../../redux/settings/scout/scoutSettingsReducer';

const ScoutSettings = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetScoutSettingsData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route path='/scout/' element={<WritersList />} />
      <Route path='/scout/add-writer' element={<AddWriter />} />
      <Route path='/scout/edit-writer/:id' element={<EditWriter />} />
    </Routes>
  );
};

export default ScoutSettings;
